import { render } from "./CreatePostForm.vue?vue&type=template&id=726aceb2"
import script from "./CreatePostForm.vue?vue&type=script&lang=js"
export * from "./CreatePostForm.vue?vue&type=script&lang=js"
script.render = render

export default script